import axios from 'axios';
import { createAuthenticationInterceptor, AuthType } from '@dtvgo/axios-interceptor-auth';
import { createClientHeadersInterceptor } from './interceptors/clientHeaders.js';
import './utils/index.js';
import './utils/normalizr/constants.js';
import './utils/normalizr/entities.js';
import 'query-string';
import '@dtvgo/typed-normalizr';
import '@dtvgo/constants';
import './utils/normalizr/interfaces.js';
import './utils/normalizr/utils.js';
import 'lodash/set';
import 'lodash/sortBy';
import 'lodash/mapKeys';
import 'lodash/defaultsDeep';

function createAxiosInstance({
  timeout,
  host,
  clientType,
  getAccessTokenData,
  language,
  getIsBrazil,
  authInterceptor,
  ...clientHeadersOptions
}) {
  const backendAxiosInstance = axios.create({
    baseURL: host,
    responseType: "json",
    headers: {
      "Content-Type": "application/json"
    },
    timeout
  });
  async function getSessionTokenForAuthInterceptor() {
    const { idToken } = await getAccessTokenData();
    return idToken;
  }
  async function addThinkAnalyticsParamsToRequest(thinkAnalyticsRequestConfig) {
    const {
      includeTimeZone,
      includeClientType,
      includeDeviceType,
      method,
      ...axiosRequestConfig
    } = thinkAnalyticsRequestConfig;
    const useData = method === "post" || method === "put" || method === "patch";
    let newParams = axiosRequestConfig[useData ? "data" : "params"];
    if (!newParams) {
      newParams = {};
    }
    if (includeTimeZone) {
      const match = /GMT([+-]?\d{2})(\d{2})/.exec((/* @__PURE__ */ new Date()).toString());
      newParams.timeZone = `${match[1]}:${match[2]}`;
    }
    if (includeClientType) {
      newParams.clientType = clientType;
    }
    if (includeDeviceType) {
      newParams.deviceType = clientType;
    }
    return {
      method,
      ...axiosRequestConfig,
      [useData ? "data" : "params"]: newParams
    };
  }
  async function addLanguageParamToRequest(axiosRequestConfig) {
    const { includeLanguage, params, ...requestConfig } = axiosRequestConfig;
    const newParams = params || {};
    if (includeLanguage) {
      if (language) {
        newParams.language = typeof language === "function" ? await language() : language;
      } else if (getIsBrazil) {
        const isBrazil = await getIsBrazil();
        newParams.language = isBrazil ? "pt" : "es";
      } else if (!newParams.language) {
        console.warn("[backend-service] Request is required to include language but an strategy to include it was not provided", axiosRequestConfig.url);
      }
    }
    return {
      ...requestConfig,
      params: newParams
    };
  }
  const authenticationInterceptor = createAuthenticationInterceptor({
    type: AuthType.SESSION_TOKEN,
    options: {
      sessionToken: getSessionTokenForAuthInterceptor
    }
  });
  const clientHeadersInterceptor = createClientHeadersInterceptor(clientHeadersOptions);
  backendAxiosInstance.interceptors.response.use(void 0, authInterceptor);
  backendAxiosInstance.interceptors.request.use(authenticationInterceptor);
  backendAxiosInstance.interceptors.request.use(addThinkAnalyticsParamsToRequest);
  backendAxiosInstance.interceptors.request.use(clientHeadersInterceptor);
  backendAxiosInstance.interceptors.request.use(addLanguageParamToRequest);
  return backendAxiosInstance;
}

export { createAxiosInstance as default };
//# sourceMappingURL=createAxiosInstance.js.map
